import React from 'react';

import HowToRecycleBanner from './HowToRecycleBanner';
import { HowToRecycleBannerData } from './HowToRecycleBanner/models';

interface HowToRecycleBannerPropsRaw {
  finishLogo: { url: string };
  heading?: string;
  icon1?: { url: string };
  icon2?: { url: string };
  icon3?: { url: string };
  bgImageMobile?: { url: string };
  bgImageDesktop?: { url: string };
  icon1Text?: string;
  icon2Text?: string;
  icon3Text?: string;
}

const HowToRecycleBannerWrapper = (props: HowToRecycleBannerPropsRaw) => {
  const {
    finishLogo,
    heading,
    icon1,
    icon2,
    icon3,
    bgImageMobile,
    bgImageDesktop,
    icon1Text,
    icon2Text,
    icon3Text,
  } = props;

  const data: HowToRecycleBannerData = {
    finishLogo,
    heading,
    icon1,
    icon2,
    icon3,
    bgImageMobile,
    bgImageDesktop,
    icon1Text,
    icon2Text,
    icon3Text,
  };

  return <HowToRecycleBanner data={data} />;
};

HowToRecycleBannerWrapper.displayName = 'HowToRecycleBannerWrapper';
export default HowToRecycleBannerWrapper;
